/**
 * referentActivites Module
 */
 import Vue from 'vue';
 import { apiModel, makeApiRequest } from "../../../api";
 import _ from "lodash";
 // States
 const state = {
     referentActivite: [],
     referentActivites: [],
 };
 
 // Getters
 const getters = {
    referentActivites: state => {
        return state.referentActivites
   },
    pecActivite: state => {
        return state.pecActivite
   },

    activitesList: state => {
        return state.activitesList
    }
 };
 
 // Actions
 const actions = {
     getReferentActivites(context, payload) {
         function successCallback(response) {
             context.commit('getReferentActivitesHandler', { referentActivites: response.data.activites });
            
         }
 
         function errorCallback(error) {
             Vue.swal(
                 payload.errorMessages.error,
                 '',
                 'error'
             );
         }
 
         const localToken = localStorage.getItem('ms-token');
        //  console.log(apiModel.ReferentActivite.List)
         makeApiRequest(payload.args, apiModel.ReferentActivite.List, localToken, successCallback, errorCallback, payload.errorMessages);
     },
    //  createReferentActivite(context, payload) {
    //     function successCallback(response) {
    //         context.commit('createReferentActiviteHandler', { referentActivite: response.data.activite });
           
    //     }

    //     function errorCallback(error) {
    //         Vue.swal(
    //             payload.errorMessages.error,
    //             '',
    //             'error'
    //         );
    //     }

    //     const localToken = localStorage.getItem('ms-token');

    //     makeApiRequest(payload.args, apiModel.ReferentActivite.createActivite, localToken, successCallback, errorCallback, payload.errorMessages);
    // },
    // getPec(context, payload) {
    //     function successCallback(response) {
    //         context.commit('getPecHandler', { pecActivite: response.data.activite });
           
    //     }

    //     function errorCallback(error) {
    //         Vue.swal(
    //             payload.errorMessages.error,
    //             '',
    //             'error'
    //         );
    //     }

    //     const localToken = localStorage.getItem('ms-token');

    //     makeApiRequest(payload.args, apiModel.PecActivite.ListPec, localToken, successCallback, errorCallback, payload.errorMessages);
    // },
 
     createReferentActivite(context, payload) {
         function successCallback(response) {
             Vue.swal(
                 payload.successMessage,
                 '',
                 'success'
             );
         }
 
         function errorCallback(error) {
             Vue.swal(
                 payload.errorMessages.error,
                 '',
                 'error'
             );
         }
 
         const localToken = localStorage.getItem('ms-token');
 
         makeApiRequest(payload.args, apiModel.ReferentActivite.createActivite, localToken, successCallback, errorCallback, payload.errorMessages);
     },
 
 };
 
 // Mutations
 const mutations = {
     getReferentActivitesHandler(state, { referentActivites }) {
        let toDo = [];
        let enCours = [];
        let termine = [];
        let gArray = [];

        _.forEach(referentActivites,function(item){  
                    if(item.statut==="En cours"){
                        enCours.push(item);
                    }else if(item.statut==="Terminé"){
                        termine.push(item);
                    }else {
                        toDo.push(item);
                    }
        });

        gArray.push({id: 1, title: 'toDo',tasks: toDo});
        gArray.push({id: 2, title: 'doing',tasks: enCours});
        gArray.push({id: 3, title: 'cloture',tasks: termine});
        state.referentActivites = gArray;
        state.activitesReferentList = referentActivites;
     },
 
     getReferentActiviteHandler(state, { referentActivite }) {
         // Update referentActivite state
         state.referentActivite = referentActivite;
     },
 
 };
 
 export default {
     state,
     getters,
     actions,
     mutations
 }